import { render, staticRenderFns } from "./PasswordCheckComment.vue?vue&type=template&id=6fc0a6dc"
import script from "./PasswordCheckComment.ts?vue&type=script&lang=ts&external"
export * from "./PasswordCheckComment.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports